module.exports = __webpack_public_path__ + "img/ru-cu.58957605.svg";